import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // console.log(store.state.Auth.user);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters["Auth/isAuthenticate"]) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      if (to.matched.some(record => record.meta.isDtacAdmin)) {
        if (store.getters["Auth/isDtacAdmin"]) {
          next();
        } else {
          next({ path: "/portal" });
        }
      } else if (to.matched.some(record => record.meta.isCorporateAdmin)) {
        if (store.getters["Auth/isCorporateAdmin"]) {
          next();
        } else {
          next({ path: "/portal" });
        }
      } else if (to.matched.some(record => record.meta.isReadOnly)) {
        if (store.getters["Auth/isReadOnly"]) {
          next();
        } else {
          next({ path: "/portal" });
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    next();
  } else {
    next();
  }
});

export default router;
